module.exports = "/images/icon-play.svg?b6a00ec0a1b5369062f5b30791b5b542";